import { Link } from 'react-router';
import { buildMeta, breadcrumbSchema } from '~/lib/seo';
import { SITE } from '~/data/site';

export function meta() {
  return buildMeta({
    title: 'About us',
    description:
      'A Tampa Bay commercial cleaning company, formed in 2025 and based in Brandon. W-2 crews, published prices, and the honest version of who we are.',
    path: '/about',
    jsonLd: breadcrumbSchema([
      { name: 'Home', url: '/' },
      { name: 'About', url: '/about' },
    ]),
  });
}

export default function About() {
  return (
    <>
      <section className="hero dusk grain">
        <div className="shell">
          <div className="hero-inner">
            <p className="eyebrow-pill">About</p>
            <h1>Named after the shift that does the work.</h1>
            <p className="lede">
              Second shift is the crew that clocks in when the day shift goes home. That is the
              whole business: the people who keep a building running while nobody is watching.
            </p>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="shell">
          <div className="shell-narrow">
            <div className="stack">
              <h2>The honest version</h2>
              <p>
                Second Shift Cleaning is a Tampa Bay company, formed in 2025 and based in Brandon.
                We are not going to tell you we have been here fifteen years, because we have not,
                and it would take you about a minute to find that out.
              </p>
              <p>
                We would rather start smaller and be believed than start louder and get checked.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="night-band">
        <div className="shell">
          <div className="stack-lg">
            <div className="stack" style={{ maxWidth: '46ch' }}>
              <p className="eyebrow">What we are trying to build</p>
              <h2>A job worth keeping, on the second shift.</h2>
              <p>
                Cleaning has a turnover problem, and turnover is why your building gets a different
                crew every few months. The fix is not a better checklist — it is paying people
                properly and hiring them as employees.
              </p>
              <p>
                Every technician here is a W-2 employee, not a subcontractor. That costs more. It is
                also the only version of this business where the same person is still cleaning your
                building a year from now.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="shell">
          <div className="section-head">
            <p className="eyebrow">How we work</p>
            <h2>Three things we hold to.</h2>
          </div>

          <div className="grid-3">
            <div className="card">
              <h4>Say the true thing</h4>
              <p>
                Including when it is less impressive. If we have not done something before, we will
                tell you that rather than find out on your building.
              </p>
            </div>
            <div className="card">
              <h4>Price it once</h4>
              <p>
                The walkthrough number is the number. We would rather lose a bid than win it on a
                price we have to walk back in month two.
              </p>
            </div>
            <div className="card">
              <h4>Treat the crew properly</h4>
              <p>
                W-2 employment, real wages, and a path forward. A crew that is treated well stays,
                and a crew that stays is the entire product.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="dawn">
        <div className="shell">
          <div className="cta-inner">
            <h2>Want to meet us?</h2>
            <p>
              Twenty minutes in your building. You will know quickly whether we know what we are
              doing.
            </p>
            <div className="btn-row">
              <Link to="/quote" className="btn btn-primary">
                Book a walkthrough
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
